import { useParams } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  useGetCategoriesQuery,
  useGetSubcategoriesQuery,
  useGetQuestionsQuery,
  useGetQuestionUserLevelsQuery,
} from '@backrs_ui/grow-ui/src/redux/lifeReadiness/lifeReadiness.api';

import { LifeReadinessDashboard } from './LifeReadinessDashboard';
import { LifeReadinessQuestionnaire } from './LifeReadinessQuestionnaire';

export const LifeReadinessPageContainer = () => {
  const { user } = useAppSelector((state) => state.user);

  const { categoryId, subcategoryId } = useParams<{
    categoryId: string;
    subcategoryId: string;
  }>();

  const { data: userLevels, isLoading: isUserLevelsLoading } = useGetQuestionUserLevelsQuery(
    user?.id,
  );
  const { data: categories, isLoading: isCategoriesLoading } = useGetCategoriesQuery(undefined);
  const { data: subcategories, isLoading: isSubcategoriesLoading } =
    useGetSubcategoriesQuery(undefined);
  const { data: questions, isLoading: isQuestionsLoading } = useGetQuestionsQuery(undefined);

  const shouldShowLoader =
    isCategoriesLoading ||
    isSubcategoriesLoading ||
    isQuestionsLoading ||
    !categories ||
    !subcategories ||
    !questions ||
    isUserLevelsLoading;

  if (shouldShowLoader) {
    return <FullScreenLoading />;
  }

  const foundCategory = categories.find((c) => c.slug === categoryId);
  const foundSubcategory = subcategories.find(
    (s) =>
      s.name.toLowerCase() === subcategoryId?.toLowerCase() &&
      s.life_survey_category_id === foundCategory?.id,
  );

  if ((foundCategory && foundSubcategory) || categoryId === 'quiz') {
    return (
      <LifeReadinessQuestionnaire
        categories={categories}
        subcategories={subcategories}
        questions={questions}
        userLevels={userLevels ?? []}
        foundCategory={foundCategory ?? categories[0]}
        foundSubcategory={foundSubcategory ?? subcategories[0]}
        showExplainerCard={categoryId === 'quiz'}
      />
    );
  }

  return (
    <LifeReadinessDashboard
      categories={categories}
      subcategories={subcategories}
      questions={questions}
      userLevels={userLevels ?? []}
    />
  );
};
